export default {
    state: {
        all: [],
        filtered: [],
        categories: [],
        subcategories: [],
        categoriesLoading: false,
        categoriesLoaded: false,
    },
	actions: {
		loadCategories({ commit, state }) {
			// KAN-173: Guard against duplicate fetches — only load once
			if (state.categoriesLoaded || state.categoriesLoading) return;

			commit('setCategoriesLoading', true);

			Promise.all([
				axios.get('/api/documents/categories'),
				axios.get('/api/documents/subcategories'),
			]).then(([categoriesRes, subcategoriesRes]) => {
				commit('updateCategories', { type: 'categories', items: categoriesRes.data });
				commit('updateCategories', { type: 'subcategories', items: subcategoriesRes.data });
				commit('setCategoriesLoading', false);
				commit('setCategoriesLoaded', true);
			});
		}
	},
	mutations: {
		updateCategories(state, data) {
			state[data.type] = data.items;
		},
		setCategoriesLoading(state, val) {
			state.categoriesLoading = val;
		},
		setCategoriesLoaded(state, val) {
			state.categoriesLoaded = val;
		},
	}
};